module.exports = __webpack_public_path__ + "static/media/riskScoreZero.68a48e5b.mp3";